
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"layer",attrs:{"fill":"currentColor","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M11.83 23.5c-2.96 0-5.76-1.14-7.89-3.2A11.302 11.302 0 01.5 12.33v-.13C.48 5.84 5.64.59 11.99.5h.18c2.96 0 5.76 1.14 7.89 3.2 2.17 2.11 3.39 4.94 3.44 7.97v.14c.02 6.35-5.14 11.6-11.49 11.69h-.18zm.18-22C6.2 1.58 1.48 6.38 1.5 12.19v.13c.04 2.76 1.16 5.34 3.14 7.26 1.94 1.88 4.5 2.92 7.22 2.92h.13c5.81-.09 10.52-4.88 10.51-10.69v-.13c-.04-2.76-1.16-5.34-3.14-7.26a10.236 10.236 0 00-7.19-2.92h-.16z"}}),_c('path',{attrs:{"d":"M12 14.51c-.28 0-.5-.23-.5-.5v-7c0-.28.22-.5.5-.5s.5.22.5.5v7c0 .27-.22.5-.5.5zM12.01 17.18c-.41 0-.74-.32-.76-.72 0-.21.07-.4.21-.55a.78.78 0 01.52-.23h.03c.41.03.72.34.73.73.01.21-.07.4-.21.55a.71.71 0 01-.52.22s0 0 0 0 0 0 0 0z"}})])])
          )
        }
      }
    